// Tile type identifiers
export const TileType = {
    VOID: 0,
    // Base terrain (1-19)
    GRASS: 1,
    DIRT: 2,
    STONE: 3,
    SAND: 5,
    MUD: 7,
    // Water types (20-29)
    DEEP_WATER: 20,
    WATER: 21,
    SHALLOW_WATER: 22,
    RIVER: 23,
    FROZEN_WATER: 24,
    // Forest types (30-39)
    FOREST_FLOOR: 30,
    FOREST_GRASS: 31,
    PINE_NEEDLES: 33,
    // Desert types (40-49)
    SAND_DUNE: 40,
    CRACKED_EARTH: 41,
    ROCKY_SAND: 42,
    // Tundra types (50-59)
    SNOW: 50,
    ICE: 51,
    PERMAFROST: 52,
    TUNDRA_GRASS: 54,
    // Swamp types (60-69)
    SWAMP_WATER: 60,
    PEAT: 61,
    MARSH_GRASS: 62,
    REEDS: 63,
    // Mountain types (70-79)
    GRAVEL: 70,
    CLIFF: 72,
    // Beach/Shore (80-89)
    WET_SAND: 80,
    PEBBLES: 81,
};
export const TILE_PROPERTIES = {
    // Base
    [TileType.VOID]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'void',
    },
    [TileType.GRASS]: {
        walkable: true,
        buildable: true,
        fertility: 0.7,
        movementCost: 1,
        name: 'grass',
    },
    [TileType.DIRT]: {
        walkable: true,
        buildable: true,
        fertility: 0.3,
        movementCost: 1,
        name: 'dirt',
    },
    [TileType.STONE]: {
        walkable: true,
        buildable: true,
        fertility: 0,
        movementCost: 1,
        name: 'stone',
    },
    [TileType.SAND]: {
        walkable: true,
        buildable: true,
        fertility: 0.1,
        movementCost: 1.3,
        name: 'sand',
    },
    [TileType.MUD]: {
        walkable: true,
        buildable: true,
        fertility: 0.8,
        movementCost: 1.5,
        name: 'mud',
    },
    // Water types
    [TileType.DEEP_WATER]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'deep_water',
    },
    [TileType.WATER]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'water',
    },
    [TileType.SHALLOW_WATER]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'shallow_water',
    },
    [TileType.RIVER]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'river',
    },
    [TileType.FROZEN_WATER]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'frozen_water',
    },
    // Forest types
    [TileType.FOREST_FLOOR]: {
        walkable: true,
        buildable: true,
        fertility: 0.5,
        movementCost: 1.2,
        name: 'forest_floor',
    },
    [TileType.FOREST_GRASS]: {
        walkable: true,
        buildable: true,
        fertility: 0.6,
        movementCost: 1.1,
        name: 'forest_grass',
    },
    [TileType.PINE_NEEDLES]: {
        walkable: true,
        buildable: true,
        fertility: 0.3,
        movementCost: 1.1,
        name: 'pine_needles',
    },
    // Desert types
    [TileType.SAND_DUNE]: {
        walkable: true,
        buildable: true,
        fertility: 0,
        movementCost: 1.8,
        name: 'sand_dune',
    },
    [TileType.CRACKED_EARTH]: {
        walkable: true,
        buildable: true,
        fertility: 0.05,
        movementCost: 1,
        name: 'cracked_earth',
    },
    [TileType.ROCKY_SAND]: {
        walkable: true,
        buildable: true,
        fertility: 0.05,
        movementCost: 1.2,
        name: 'rocky_sand',
    },
    // Tundra types
    [TileType.SNOW]: {
        walkable: true,
        buildable: true,
        fertility: 0,
        movementCost: 1.4,
        name: 'snow',
    },
    [TileType.ICE]: {
        walkable: true,
        buildable: true,
        fertility: 0,
        movementCost: 1.1,
        name: 'ice',
    },
    [TileType.PERMAFROST]: {
        walkable: true,
        buildable: true,
        fertility: 0.1,
        movementCost: 1,
        name: 'permafrost',
    },
    [TileType.TUNDRA_GRASS]: {
        walkable: true,
        buildable: true,
        fertility: 0.3,
        movementCost: 1,
        name: 'tundra_grass',
    },
    // Swamp types
    [TileType.SWAMP_WATER]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'swamp_water',
    },
    [TileType.PEAT]: {
        walkable: true,
        buildable: true,
        fertility: 0.9,
        movementCost: 1.6,
        name: 'peat',
    },
    [TileType.MARSH_GRASS]: {
        walkable: true,
        buildable: true,
        fertility: 0.7,
        movementCost: 1.3,
        name: 'marsh_grass',
    },
    [TileType.REEDS]: {
        walkable: true,
        buildable: true,
        fertility: 0.4,
        movementCost: 1.5,
        name: 'reeds',
    },
    // Mountain types
    [TileType.GRAVEL]: {
        walkable: true,
        buildable: true,
        fertility: 0,
        movementCost: 1.3,
        name: 'gravel',
    },
    [TileType.CLIFF]: {
        walkable: false,
        buildable: false,
        fertility: 0,
        movementCost: Infinity,
        name: 'cliff',
    },
    // Beach types
    [TileType.WET_SAND]: {
        walkable: true,
        buildable: true,
        fertility: 0.05,
        movementCost: 1.4,
        name: 'wet_sand',
    },
    [TileType.PEBBLES]: {
        walkable: true,
        buildable: true,
        fertility: 0,
        movementCost: 1.2,
        name: 'pebbles',
    },
};
// Water tile identification
const WATER_TILE_TYPES = new Set([
    TileType.DEEP_WATER,
    TileType.WATER,
    TileType.SHALLOW_WATER,
    TileType.RIVER,
    TileType.FROZEN_WATER,
    TileType.SWAMP_WATER,
]);
export const isWaterTile = ({ tileType }) => {
    return WATER_TILE_TYPES.has(tileType);
};
// Get tile index in chunk array
export const getTileIndex = ({ localX, localY, chunkSize, }) => {
    return localY * chunkSize + localX;
};
// Get tile at local coordinates from chunk data
export const getTileAt = ({ chunk, localX, localY, chunkSize, }) => {
    const index = getTileIndex({ localX, localY, chunkSize });
    return (chunk.tiles[index] ?? TileType.VOID);
};
// Convert world tile coordinates to chunk coordinates with local position
export const tileToChunkCoords = ({ tileX, tileY, chunkSize, }) => {
    const chunkX = Math.floor(tileX / chunkSize);
    const chunkY = Math.floor(tileY / chunkSize);
    const localX = ((tileX % chunkSize) + chunkSize) % chunkSize;
    const localY = ((tileY % chunkSize) + chunkSize) % chunkSize;
    return { chunkX, chunkY, localX, localY };
};
//# sourceMappingURL=types.js.map